const PDF_REPORT_PATH = /^\/projects\/[^/]+\/report\/?$/

export function isTokenizedPdfReportRoute(
  pathname: string,
  search: string,
): boolean {
  const token = new URLSearchParams(search).get('reportAccessToken')?.trim()
  return PDF_REPORT_PATH.test(pathname) && Boolean(token)
}

/**
 * The published language a project report page switches to itself, from the
 * `languageTag` its link carries.
 */
export function reportPageLanguageTag(
  pathname: string,
  languageTag: unknown,
): string | undefined {
  return PDF_REPORT_PATH.test(pathname) && typeof languageTag === 'string' && languageTag
    ? languageTag
    : undefined
}
